export default {
    getCustomerContracts: { method: 'get', url: 'emcadmin/customers/contracts' },
    postCustomerContracts: { method: 'post', url: 'emcadmin/customers/contracts' },
    putCustomerContracts: { method: 'put', url: 'emcadmin/customers/contracts/{id}' },
    deleteCustomerContracts: { method: 'delete', url: 'emcadmin/customers/contracts/{id}' },
}
